export default "__VITE_PUBLIC_ASSET__0783b6ab__"